/** @flow */

import type { UserAccountsState } from "./types";

export const initialState: UserAccountsState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: null,
    totalElements: 0,
  },
  filterInitialValues: {
    isEnabled: "true",
  },
  userTypes: [],
  error: null,
};

export default initialState;
